// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "segment-1GMdw";
var _3 = "points-1gpP2";
var _4 = "duration-3itdK";
var _5 = "weather-2GQJa";
var _6 = "weather__row-3rCZe";
var _7 = "weather__icon-2taxX";
var _8 = "weather__temperature-1Hwzx";
var _9 = "flight-1T2If";
var _a = "amenities-wL33M";
var _b = "flight__infoIcon-2zWr-";
var _c = "flight__ecoIcon-3wspo";
var _d = "airline-1MbaU";
var _e = "logo-2z7Lh";
var _f = "plane-VKeGo";
var _10 = "plane__image__stub-3G-WU";
var _11 = "transfer-lVS8M";
var _12 = "nextDayArrival-28plM";
var _13 = "aircraft__name__link-1gcbX";
var _14 = "aircraft__name-2zDVU";
export { _1 as "__esModule", _2 as "segment", _3 as "points", _4 as "duration", _5 as "weather", _6 as "weather__row", _7 as "weather__icon", _8 as "weather__temperature", _9 as "flight", _a as "amenities", _b as "flight__infoIcon", _c as "flight__ecoIcon", _d as "airline", _e as "logo", _f as "plane", _10 as "plane__image__stub", _11 as "transfer", _12 as "nextDayArrival", _13 as "aircraft__name__link", _14 as "aircraft__name" }
export default { "__esModule": _1, "segment": _2, "points": _3, "duration": _4, "weather": _5, "weather__row": _6, "weather__icon": _7, "weather__temperature": _8, "flight": _9, "amenities": _a, "flight__infoIcon": _b, "flight__ecoIcon": _c, "airline": _d, "logo": _e, "plane": _f, "plane__image__stub": _10, "transfer": _11, "nextDayArrival": _12, "aircraft__name__link": _13, "aircraft__name": _14 }
